import { FormControl, FormGroup } from '@angular/forms';
import { UserPermissionsEnum } from '../enums/user-permissions.enum';

export type ManagedUserProfileForm = FormGroup<{
  email: FormControl<string | null>;
  firstName: FormControl<string | null>;
  lastName: FormControl<string | null>;
  phone: FormControl<string | null>;
}>;

export type ManagedUserPermissionsForm = FormGroup<{
  viewCatalogue: FormControl<boolean>;
  showPrices: FormControl<boolean>;
  showPricelistDiscount: FormControl<boolean>;
  viewAndCreateOffers: FormControl<boolean>;
  createOrders: FormControl<boolean>;
  viewOrders: FormControl<boolean>;
  viewOrdersOnCompanyLevel: FormControl<boolean>;
  viewAndCreateProjectReservations: FormControl<boolean>;
  viewProjectReservationsOnCompanyLevel: FormControl<boolean>;
  viewCmprs: FormControl<boolean>;
  createCmprs: FormControl<boolean>;
  viewCustomMadePriceEstimates: FormControl<boolean>;
  viewCmprsOnCompanyLevel: FormControl<boolean>;
  viewAndCreateClaims: FormControl<boolean>;
  viewClaimsOnCompanyLevel: FormControl<boolean>;
  // Information pages form controls:
  [key: string]: FormControl<boolean>;
  viewEstimatedLeadTimePage: FormControl<boolean>;
  viewCompanyInformation: FormControl<boolean>;
  viewPurchaseAndSalesAgreement: FormControl<boolean>;
}>;

export type PermissionsFormControlNames = keyof ManagedUserPermissionsForm['controls'];

export type ManagedUserPermissionsFormValue = ReturnType<ManagedUserPermissionsForm['getRawValue']>;

export const formControlsToPermissionsEnumMap: Record<keyof ManagedUserPermissionsFormValue, UserPermissionsEnum> = {
  viewCatalogue: UserPermissionsEnum.VIEW_CATALOGUE,
  showPrices: UserPermissionsEnum.SEE_PRICES,
  showPricelistDiscount: UserPermissionsEnum.SEE_PRICE_LIST_DISCOUNT,
  viewAndCreateOffers: UserPermissionsEnum.VIEW_AND_CREATE_OFFERS,
  createOrders: UserPermissionsEnum.CREATE_ORDERS,
  viewOrders: UserPermissionsEnum.VIEW_ORDERS,
  viewOrdersOnCompanyLevel: UserPermissionsEnum.VIEW_ORDERS_ON_COMPANY_LEVEL,
  viewAndCreateProjectReservations: UserPermissionsEnum.VIEW_AND_CREATE_PROJECT_RESERVATIONS,
  viewProjectReservationsOnCompanyLevel: UserPermissionsEnum.VIEW_PROJECT_RESERVATIONS_ON_COMPANY_LEVEL,
  viewCmprs: UserPermissionsEnum.VIEW_CMPR,
  createCmprs: UserPermissionsEnum.CREATE_CMPR,
  viewCustomMadePriceEstimates: UserPermissionsEnum.VIEW_CUSTOM_MADE_PRICE_ESTIMATES,
  viewCmprsOnCompanyLevel: UserPermissionsEnum.VIEW_CMPR_ON_COMPANY_LEVEL,
  viewAndCreateClaims: UserPermissionsEnum.VIEW_AND_CREATE_CLAIMS,
  viewClaimsOnCompanyLevel: UserPermissionsEnum.VIEW_CLAIMS_ON_COMPANY_LEVEL,
  viewEstimatedLeadTimePage: UserPermissionsEnum.VIEW_ORDERS_LEAD_TIME,
  viewPurchaseAndSalesAgreement: UserPermissionsEnum.VIEW_PURCHASE_AND_SALES_AGREEMENT,
  viewCompanyInformation: UserPermissionsEnum.VIEW_COMPANY_INFO,
};
